function initVariantSelection() {
  const addToCartBtns = document.querySelectorAll(".m-add-to-cart");
  const buyOneClickWrappers = document.querySelectorAll(".buy-one-click");
  const buyOneClickFy = document.querySelectorAll(".flexy-btn");
  const variantSelects = document.querySelectorAll("select[name='id']");
  const variantRadios = document.querySelectorAll(".m-product-option__input");

  function updateButtons(hasSelection) {
    if (document.body.classList.contains('gift-card')) {
      document.querySelectorAll('.flexy-btn').forEach(btn => {
        btn.classList.remove('is-disabled');
      });
      return; // Skip disable logic for gift card products
    }

    if (hasSelection) {
      addToCartBtns.forEach(btn => btn.classList.remove("is-disabled"));
      buyOneClickWrappers.forEach(wrapper => wrapper.classList.remove("is-disabled"));
      buyOneClickFy.forEach(btn => btn.classList.remove("is-disabled"));
    } else {
      addToCartBtns.forEach(btn => btn.classList.add("is-disabled"));
      buyOneClickWrappers.forEach(wrapper => wrapper.classList.add("is-disabled"));
      buyOneClickFy.forEach(btn => btn.classList.add("is-disabled"));
    }
  }

  function syncSelection(selectedValue) {
    // Sync selects
    variantSelects.forEach(select => {
      if (select.value !== selectedValue) {
        select.value = selectedValue;
      }
    });

    // Sync radios
    variantRadios.forEach(radio => {
      radio.checked = radio.value === selectedValue;
    });

    updateButtons(!!selectedValue);
  }

  // Force all unselected at start
  variantSelects.forEach(select => (select.selectedIndex = 0));
  variantRadios.forEach(radio => (radio.checked = false));
  updateButtons(false);

  // Handle select changes
  variantSelects.forEach(select => {
    select.addEventListener("change", () => {
      syncSelection(select.value);
    });
  });

  // Handle radio changes
  variantRadios.forEach(radio => {
    radio.addEventListener("change", () => {
      if (radio.checked) {
        syncSelection(radio.value);
      }
    });
  });
}


function initDisabledButtonsModal() {
  if (document.body.classList.contains("gift-card")) {
    return;
  }

  const modal = document.getElementById("customModal");
  const closeBtn = document.querySelector(".custom-modal-close");

  // Handle Add to Cart clicks
  document.querySelectorAll(".m-add-to-cart").forEach(addToCartBtn => {
    addToCartBtn.addEventListener("click", e => {
      if (addToCartBtn.classList.contains("is-disabled")) {
        e.preventDefault();
        e.stopImmediatePropagation();
        modal.style.display = "block";
      }
    });
  });

  // Handle Buy Now clicks
  document.querySelectorAll(".buy-one-click").forEach(buyNowWrapper => {
    const buyNowBtn = buyNowWrapper.querySelector("button");
    if (buyNowBtn) {
      buyNowBtn.addEventListener(
        "click",
        e => {
          if (buyNowWrapper.classList.contains("is-disabled")) {
            e.preventDefault();
            e.stopImmediatePropagation();
            modal.style.display = "block";
          }
        },
        true // capture
      );
    }
  });

  // Close modal
  if (closeBtn) {
    closeBtn.addEventListener("click", () => {
      modal.style.display = "none";
    });
  }

  window.addEventListener("click", e => {
    if (e.target === modal) {
      modal.style.display = "none";
    }
  });
}

// ✅ Run on page load
document.addEventListener("DOMContentLoaded", () => {
  initVariantSelection();
  initDisabledButtonsModal();
});
 
document.addEventListener('click', function (e) {
  const button = e.target.closest('.code_copy');
  if (!button) return;

  e.preventDefault();

  const wrapper = button.closest('.offer-wrapper');
  if (!wrapper) return;

  const descriptionElem = wrapper.querySelector('.offer-title p');
  if (!descriptionElem) return;

  const description = descriptionElem.innerText.trim();

  navigator.clipboard.writeText(description).then(() => {
    // Save original state ONCE
    const originalText = 'Copy';
    const originalColor = '';

    // Update UI
    button.innerText = 'Copied';
    button.style.color = '#28a745';

    // Clear previous timer if exists
    if (button._copyTimeout) {
      clearTimeout(button._copyTimeout);
    }

    // Revert after 2 seconds
    button._copyTimeout = setTimeout(() => {
      button.innerText = originalText;
      button.style.color = originalColor;
    }, 2000);
  }).catch(err => {
    console.error('Failed to copy!', err);
  });
});


document.addEventListener('click', function (e) {
  const badge = e.target.closest('.jdgm-preview-badge--with-link');

  if (!badge) return;

  const reviews = document.querySelector('.section-drapepanda-reviews');

  if (!reviews) {
    console.log('Reviews section not found');
    return;
  }

  e.preventDefault();
  e.stopPropagation();
  e.stopImmediatePropagation();

  const headerOffset = 80; // change this if you have a sticky header
  const elementPosition = reviews.getBoundingClientRect().top;
  const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

  window.scrollTo({
    top: offsetPosition,
    behavior: 'smooth'
  });
}, true);
